// TOUCH SUPPORT
document.body.classList.toggle("ontouchstart" in window ? "touch" : "no-touch");
